import React from 'react';
import { connect } from 'react-redux';

import TrackingPage from './pages/TrackingPage';
import ErrorPage from './components/ErrorPage';

export class App extends React.PureComponent {
  render() {
    const {
      isPreview,
      isDummy,
      tracking: { error: trackingError, loaded: isTrackingLoaded },
      settings: {
        settings: { widgets, settings: designSettings } = {},
        error: settingsError,
        loaded: isSettingsLoaded,
      },
      language,
      onChangeLanguage,
    } = this.props;

    if (trackingError || settingsError) {
      return <ErrorPage type={getErrorType({ trackingError, settingsError })} language={language} />;
    }

    if (!isTrackingLoaded || !isSettingsLoaded) {
      return null;
    }

    return (
      <TrackingPage
        isPreview={isPreview}
        isDummy={isDummy}
        widgets={widgets}
        designSettings={designSettings}
        onChangeLanguage={onChangeLanguage}
      />
    );
  }
}

function getErrorType({ trackingError, settingsError }) {
  if (settingsError && settingsError.status === 404) {
    // if fetching widget settings failed it doesn't matter what is going on with tracking data
    return 'not-found';
  }

  if (trackingError && trackingError.status === 404) {
    return 'no-info';
  }

  return 'error';
}

function mapStateToProps(state) {
  const { tracking, settings, language } = state;

  return {
    tracking,
    settings,
    language,
  };
}

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/js/app.js